import { useQuery } from '@tanstack/react-query';
import getStudio from 'Api/studio/getStudio';
import getStudioRequest from './model/request/getStudioRequest';
import getStudioResponse from './model/response/getStudioResponse';

const useGetStudio = ({ queryParams }) => {
  return useQuery({
    queryKey: ['studio', queryParams],
    queryFn: async () => {
      const queries = getStudioRequest(queryParams);

      const response = await getStudio(queries);

      const result = getStudioResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetStudio;
